import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  BookSlotPromptFlashMessage,
  BookSlotPromptModal,
} from '[theme-lib]/apps/bookSlotPrompt/containers/BookSlotPromptRender';

import {
  redirectToSlotBooking,
  reportDisplayToWA,
  showBookASlotMessage,
} from '../actions/bookSlotPrompt';

export class BookSlotPromptComponent extends PureComponent {
  static propTypes = {
    basketSize: PropTypes.number.isRequired,
    isSlotBooked: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
    onConfirm: PropTypes.func.isRequired,
    onShow: PropTypes.func,
    showBookASlotPrompt: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.basketSize !== state.prevBasketSize) {
      return {
        prevBasketSize: props.basketSize,
        isVisible: state.prevBasketSize === 0 && props.basketSize > 0 &&
        !props.isSlotBooked && !state.isRequestInProgress,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      prevBasketSize: props.basketSize || 0, // eslint-disable-line react/no-unused-state
      isVisible: false,
      isRequestInProgress: false,
    };
  }

  componentDidMount = () => {
    // FlashMessages should work more like popups, right now you can't
    // add event handlers to FlashMessage content and this workaround is required
    window.handleBookSlotPromptConfirmClick = this.handleConfirmClick;
  }

  componentDidUpdate = () => {
    const { onShow } = this.props;
    if (!this.shouldShowBookSlotPrompt()) {
      return null;
    }

    if (!this.state.isRequestInProgress && typeof onShow === 'function') {
      onShow();
    }

    BookSlotPromptFlashMessage(this.props.showBookASlotPrompt);

    return null;
  }

  componentWillUnmount = () => {
    delete window.handleBookSlotPromptConfirmClick;
  }

  handleCloseClick = () => {
    this.setState({
      isVisible: false,
    });
  }

  handleConfirmClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({
      isRequestInProgress: true,
    });
    this.props.onConfirm();
  }

  shouldShowBookSlotPrompt = () => this.state.isVisible && !this.state.isRequestInProgress;

  render() {
    return BookSlotPromptModal(this.shouldShowBookSlotPrompt(), this.handleConfirmClick, this.handleCloseClick);
  }
}

export default connect(
  (state) => ({
    basketSize: state.basket.numberOfItems,
    isSlotBooked: !!(state.deliverySlot && state.deliverySlot.startTime),
  }), {
    onConfirm: redirectToSlotBooking,
    onShow: reportDisplayToWA,
    showBookASlotPrompt: showBookASlotMessage,
  }
)(BookSlotPromptComponent);
